'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../../../node_modules/classnames/index.js');
var NavList = require('../../DesktopNavbar/DesktopList/NavList.js');
require('./DropdownNav.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var DropdownNav = function (props) {
    var _a = React.useState(null), hoveredChild = _a[0], setHoveredChild = _a[1];
    var menu = props.menu, _b = props.isSelected, isSelected = _b === void 0 ? false : _b, _c = props.isDesktop, isDesktop = _c === void 0 ? false : _c; props.isShowChild; var level = props.level;
    var itemClass;
    var switchClass = function (level) {
        switch (level) {
            case 1:
                itemClass = 'primary_dropdown_menu';
                break;
            case 2:
                itemClass = 'secondary_dropdown_menu';
                break;
            default:
                itemClass = '';
        }
        return itemClass;
    };
    return (React__default['default'].createElement("ul", { className: index['default'](switchClass(level), isSelected && 'show'), onMouseLeave: function () {
            setHoveredChild(undefined);
        } }, menu.map(function (item) { return (React__default['default'].createElement(NavList.NavList, { level: level, key: item.title, item: item, isDesktop: isDesktop, onMouseOver: function () {
            setHoveredChild(item);
        }, onMouseLeave: function () {
            setHoveredChild(undefined);
        }, isSelected: hoveredChild && hoveredChild.title === item.title })); })));
};

exports.DropdownNav = DropdownNav;
//# sourceMappingURL=DropdownNav.js.map
